/**
 * The display label of an ArTable column: the column's `descriptionOverride`
 * short label, then the field type's short label, then `cacheDescription`, then
 * the raw `typeId`. Consumers: `ArTableHeader`, `ArTableControls`, the card-mode
 * labels in `ArRow`, `ArBundleHeaderRow` and `ArTableAggregations`, and
 * `useArTableExport`. The field type step applies to `Field` columns only — any
 * other column kind (an entity reference, a meta field) may share a `typeId`
 * with a field type it does not represent.
 */

import type { ArColumnDefinition } from '#types/System.Artifacts.types';
import { UIElementType } from '#types/System.types';
import type { FieldType } from '#types/System.types';

const resolveArColumnLabel = (
  column: ArColumnDefinition,
  fieldTypes: Record<string, FieldType>,
): string => {
  const fieldTypeLabel =
    column.uiElementType === UIElementType.Field
      ? fieldTypes[column.typeId]?.description?.shortLabel
      : undefined;

  return (
    column.descriptionOverride?.shortLabel ??
    fieldTypeLabel ??
    column.cacheDescription ??
    column.typeId
  );
};

export default resolveArColumnLabel;
